<script setup lang="ts">
import {Section} from "@/types";
import CourseTimeTableItem from "components/course/detail/CourseTimeTableItem.vue";

defineProps<{
  course_status: number
  course_type: number
  is_fake: number
  sections: Section[]
}>()

const emit = defineEmits(['addSection', 'editSection',
  "startLive", 'deleteSection', 'onChangeVideo', "studyList", "onUpDown", "batchAddSection", "onVideoClick"])

const addSection = () => {
  emit("addSection")
}

const onEdit = (id: number) => {
  emit("editSection", id)
}

const onDelete = (id: number) => {
  emit("deleteSection", id)
}

const onStartLive = (id: number) => {
  emit("startLive", id)
}

const onChangeVideo = (id: number, video_id: string) => {
  emit("onChangeVideo", id, video_id)
}

const studyList = (id: number, course_type: number) => {
  emit("studyList", id, course_type);
}

const onUpDown = (status: number, id: number) => {
  emit("onUpDown", status, id);
}

const onVideoClick = (id: number,type:number) => {
  emit("onVideoClick", id,type)
}

const batchAddSection = () => {
  emit("batchAddSection")
}
</script>

<template>
  <div class="py-1.5rem px-2rem bg-white rounded-md shadow-md">
    <div class="flex justify-between">
      <div class="color-[rgba(0,0,0,0.85)] text-1.25em font-bold">课程表</div>
      <el-button type="primary" v-if="course_type === 2 && sections.length === 0" @click="batchAddSection">批量新增章节</el-button>
    </div>
    <course-time-table-item
        v-for="(section, index) in sections"
        :key="index"
        :index="index"
        :course_status="course_status"
        :course_type="course_type"
        :section="section"
        :is_fake="is_fake"
        @on-edit="onEdit"
        @on-delete="onDelete"
        @start-live="onStartLive"
        @study-list="studyList"
        @on-change-video="onChangeVideo"
        @on-up-down="onUpDown"
        @on-video-click="onVideoClick">
    </course-time-table-item>
    <div class="plus-container border-dashed py-.375rem border-1px
     border-#D9D9D9 mt-2rem flex justify-center items-center
     text-[rgba(0,0,0,0.65)] text-.875em cursor-pointer" @click="addSection">
      <img src="@/assets/image/icon/icon-plus.png" alt="plus-icon" class="w-.875rem h-.875rem"/>
      <span class="ml-.5rem">新增一讲</span>
    </div>
  </div>
</template>

<style scoped>
</style>
